/*
 * @Author: your name
 * @Date: 2020-08-21 18:15:16
 * @LastEditTime: 2020-10-13 13:37:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \eunke-st-www\src\server\financial.js
 */
import http from "../utils/http";
export default{
    waybillPaymentPage:function(data,fun){
        http.get("/finance/payment-page",data,fun)
    },  
    withdrawPage:function(data,fun){
        http.get("/finance/withdraw-page",data,fun)
    }, 
    accountPage:function(data,fun){
        http.get("/finance/account-page",data,fun)
    }, 
    marginBackPass:function(data,fun){
        http.put("/finance/margin-back-pass",data,fun)
    }, 
    marginBackRefuse:function(data,fun){
        http.put("/finance/margin-back-refuse",data,fun)
    },  
    withdrawPassNew:function(data,fun){
        http.put("/finance/withdraw-pass-new",data,fun)
    },  
    withdrawRefuse:function(data,fun){
        http.put("/finance/withdraw-refuse",data,fun)
    },
    accountPageExport:function(data,fun){
        http.getExport("/finance/account-page-export",data,fun)
    },
    withdrawPageExport:function(data,fun){
        http.getExport("/finance/withdraw-page-export",data,fun)
    },
    waybillPaymentPageExport:function(data,fun){
        http.getExport("/finance/waybill-payment-page-export",data,fun)
    },
    getWaybillCount(data, fun) {
        http.get("/finance/account-page-count",data,fun)
    },
    getPaymentCount(data, fun) {
        http.get("/finance/payment-page-count",data,fun)
    },
    getWithdrawCount(data, fun) {
        http.get("/finance/withdraw-page-count",data,fun)
    },
    getDriverAccountCount(data, fun) {
        http.get("/finance/account-page-count",data,fun)
    },
    ownerRechargeRecord(data, fun) {
        http.get("/finance/ownerRechargeRecord",data,fun)
    },
    ownerRechargeRecordCount(data, fun) {
        http.get("/finance/ownerRechargeRecordCount",data,fun)
    },
    getOwnerAccountBalance(data, fun) {
        http.post("/finance/ownerAccountBalance",data,fun)
    },
    getOwnerAccountBalanceCount(data, fun) {
        http.post("/finance/ownerAccountBalanceCount",data,fun)
    },
    getDriverMemberRechargeRecord(data, fun) {
        http.post("/finance/driverMemberRechargeRecord",data,fun)
    },
    getDriverMemberRechargeCount(data, fun) {
        http.post("/finance/driverMemberRechargeCount",data,fun)
    },
    queryCompanyBalance(data, fun) {
        http.get("/appuser/queryCompanyBalance",data,fun)
    }, 
    queryAccountBook(data, fun) {
        http.post("/alipay/account-book-query",data,fun)
    }, 
    transferAccountBook(params, fun) {
        // http.post("/alipay/transfer-account-book",params,fun)
        // return
        return http.http.request({
            url: '/alipay/transfer-account-book',
            method: 'post',
            params
        })
    },
    invoicePage(data, fun) {
        http.get("/invoice/page",data,fun)
    },
    invoiceMain(data, fun) {
        http.post("/invoice/mail",data,fun)
    },
    queryAll(data, fun) {
        http.post("/coupon/queryAll",data,fun)
    }, 
    queryAllCount(data, fun) {
        http.post("/coupon/queryAllCount",data,fun)
    }, 
    queryAllExcle(data, fun) {
        http.post("/coupon/queryAllExcle",data,fun)
    },
    queryDetail(data, fun) {
        http.post("/coupon/queryDetail",data,fun)
    },
    completeInvice(data, fun) {
        http.post("/invoice/completeInvice",data,fun)
    },
    invoiceCount(data, fun) {
        http.get("/invoice/pageCount",data,fun)
    },
    queryAllCouponActivity(data, fun) {
        http.post("/coupon/queryAllCouponActivity",data,fun)
    },
    addCouponActivity(data, fun) {
        http.post("/coupon/addCouponActivity",data,fun)
    },
    getBase(data, fun) {
        http.get("/coupon/getBase",data,fun)
    },
    deleteCoupon(id, fun) {
        http.put(`/coupon/delete/${id}`,{},fun)
    },
}